import React from "react";
import { Col, Row } from "react-bootstrap";
import { labels } from "../../../localization/labels";
import ComponentHeader from "../ComponentHeader";
import GenericPagination from "../GenericPagination";
import SearchResult from "../SearchResult";

const createSearchResults = (
  searchResults,
  onOpen,
  openInNewTab,
  additionalContent
) => {
  return searchResults.map(result => (
    <Row className="justify-content-center">
      <Col>
        <SearchResult
          searchResult={result}
          onOpen={onOpen}
          openInNewTab={openInNewTab}
        >
          {additionalContent?.(result)}
        </SearchResult>
      </Col>
    </Row>
  ));
};

const SearchResults = ({
  searchResults,
  onOpen,
  openInNewTab,
  pageInfo,
  onPageNumberClick,
  additionalContent
}) => {
  return (
    <>
      <ComponentHeader title={labels.searchResultHeader} />
      <div className="bordered_bottom_rounded">
        {createSearchResults(
          searchResults,
          onOpen,
          openInNewTab,
          additionalContent
        )}
        <div className="d-flex justify-content-center pagination-top-margin">
          <GenericPagination
            size="sm"
            pageInfo={pageInfo}
            onPageNumberClick={onPageNumberClick}
          />
        </div>
      </div>
    </>
  );
};

export default SearchResults;
